import styles from './Grid.module.css';

interface GridInterface {
    items: JSX.Element[],
}

function Grid({ items }: GridInterface) {
    return (
        <div className={styles['grid-container']} data-testid="grid">
            {items.map((item, index) => (
                <div key={index} className={styles['grid-item']}>
                    {item}
                </div>
            ))}
        </div>
    );
}

export default Grid